import { SxProps } from '@mui/material'
import { partners } from './PartnersSlider.data'

interface PartnersSliderStyles {
  wrapper: SxProps
  heading: SxProps
  listWrapper: SxProps
  list: SxProps
  listItem: SxProps
  listItemLink: SxProps
  logo: SxProps
}
export const partnersSliderDimensions = {
  iconSize: {
    desktop: 150,
    mobile: 90,
  },
}

export const partnersSliderStyles: PartnersSliderStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 0.5, md: 1 },
    transform: { xs: 'translateY(100px)', md: 'translateY(75px)' },
  },
  heading: {
    typography: { xs: 'textMd', md: 'textLg' },
    color: 'rgba(255, 255, 255, 0.7)',
  },
  listWrapper: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    width: '100vw',
    maxWidth: 1200,
    maskImage: `linear-gradient(
      to right,
      hsla(0, 0%, 0%, 0),
      hsl(0, 0%, 0%) 20%,
      hsl(0, 0%, 0%) 80%,
      hsla(0, 0%, 0%, 0)
    )`,
  },

  list: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    listStyleType: 'none',
    padding: 0,
    flex: 1,
    width: {
      // icon size * number of items * 2 for infinite scroll
      xs: `calc(${partnersSliderDimensions.iconSize.mobile}px * ${partners.length} * 2)`,
      md: `calc(${partnersSliderDimensions.iconSize.desktop}px * ${partners.length} * 2)`,
    },

    '&::after': {
      display: 'none',
    },
  },
  listItem: {
    width: {
      xs: partnersSliderDimensions.iconSize.mobile,
      md: partnersSliderDimensions.iconSize.desktop,
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: 'slider-translate-animation 45s linear infinite',
    animationName: { xs: 'slider-translate-animation-mobile', md: 'slider-translate-animation' },
    '@keyframes slider-translate-animation': {
      to: {
        transform: `translateX(calc(-${partnersSliderDimensions.iconSize.desktop}px * ${partners.length}))`,
      },
    },
    '@keyframes slider-translate-animation-mobile': {
      to: {
        transform: `translateX(calc(-${partnersSliderDimensions.iconSize.mobile}px * ${partners.length}))`,
      },
    },
  },
  listItemLink: {
    width: '100%',
  },
  logo: {
    height: { xs: 30, md: 40 },
    color: '#8b949e',
  },
}
